export const MAX_PLAYLIST_VIDEOS = 5000;
export const MAX_BATCH_SIZE = 1000;
export const DEFAULT_PREVIEW_COUNT = 5;
export const CANDIDATE_PAGE_SIZE = 100;
